import { motion, useInView, useTransform } from 'framer-motion';
import { useRef } from 'react';

export const WordsPullUp = ({ text, className = '', style = {}, showAsterisk = false }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  
  const words = text.split(' ');
  
  return (
    <div ref={ref} className={className} style={style} data-testid="words-pull-up">
      {words.map((word, i) => {
        const isLastWord = i === words.length - 1;
        const hasAsteriskTarget = showAsterisk && isLastWord && word.endsWith('a');
        
        return (
          <motion.span
            key={i}
            initial={{ y: 20, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{
              duration: 0.5,
              delay: i * 0.08,
              ease: [0.16, 1, 0.3, 1]
            }}
            style={{ display: 'inline-block', marginRight: '0.25em', position: 'relative' }}
          >
            {word}
            {hasAsteriskTarget && (
              <span
                style={{
                  position: 'absolute',
                  top: '0.65em',
                  right: '-0.3em',
                  fontSize: '0.31em'
                }}
              >
                *
              </span>
            )}
          </motion.span>
        );
      })}
    </div>
  );
};

export const WordsPullUpMultiStyle = ({ segments, containerClassName = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  
  const allWords = [];
  segments.forEach(segment => {
    const words = segment.text.split(' ');
    words.forEach(word => {
      allWords.push({ text: word, className: segment.className });
    });
  });
  
  return (
    <div ref={ref} className={`inline-flex flex-wrap justify-center ${containerClassName}`}>
      {allWords.map((word, i) => (
        <motion.span
          key={i}
          initial={{ y: 20, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{
            duration: 0.5,
            delay: i * 0.08,
            ease: [0.16, 1, 0.3, 1]
          }}
          className={word.className}
          style={{ display: 'inline-block', marginRight: '0.25em' }}
        >
          {word.text}
        </motion.span>
      ))}
    </div>
  );
};

// Individual character component - properly uses hooks
const AnimatedChar = ({ char, index, totalChars, scrollProgress }) => {
  const charProgress = index / totalChars;
  const opacity = useTransform(
    scrollProgress,
    [Math.max(0, charProgress - 0.1), Math.min(1, charProgress + 0.05)],
    [0.2, 1]
  );
  
  return (
    <motion.span
      style={{ opacity }}
      className="inline-block"
    >
      {char === ' ' ? '\u00A0' : char}
    </motion.span>
  );
};

export const ScrollAnimatedText = ({ text, scrollProgress, className = '' }) => {
  const chars = text.split('');
  
  return (
    <div className={className}>
      {chars.map((char, i) => (
        <AnimatedChar
          key={i}
          char={char}
          index={i}
          totalChars={chars.length}
          scrollProgress={scrollProgress}
        />
      ))}
    </div>
  );
};
